<template>
	<FormTitle
		v-if="title"
		:text="title"
		:required="required"
		:title-active="titleActive"
		:error="errorText ? true : false"
		:disabled="disabled"
		:kizuna-type="kizunaType"
	/>

	<div class="form_group" :class="[formClass, { error: errorClass }]">
		<div :class="formClass">
			<vue-date-picker
				v-model="model"
				locale="jp"
				class="w-full"
				format="yyyy/MM/dd"
				auto-apply
				placeholder="yyyy/mm/dd"
				:enable-time-picker="false"
				:disabled="disabled"
				@focus="focusActive"
			/>
		</div>
	</div>
	<ErrorText :text="errorText" />
</template>

<script setup>
// その他
import ErrorText from "@/components/atoms/ErrorText.vue";
import FormTitle from "@/components/atoms/FormTitle.vue";

import { onMounted, ref, watch } from "vue";

/* ---------------------------------------------------------------------------
	props
---------------------------------------------------------------------------- */
const props = defineProps({
	title: String,
	formClass: [String, Array],
	disabled: Boolean,
	required: Boolean,
	errorText: String,
	kizunaType: Number
});
const model = defineModel();

/* ---------------------------------------------------------------------------
	computed
---------------------------------------------------------------------------- */
watch(
	() => model.value,
	(newValue, oldValue) => {
		enteredOrNotCheck(newValue);
	}
);
/* ---------------------------------------------------------------------------
data
---------------------------------------------------------------------------- */
const titleActive = ref(false);
const errorClass = ref("");
/* ---------------------------------------------------------------------------
	入力項目の判定
---------------------------------------------------------------------------- */
function enteredOrNotCheck(value) {
	// 必須かつ未入力の場合
	if (props.required && (value == "" || value == null)) {
		errorClass.value = "input-red";
		// 上記以外の場合
	} else {
		errorClass.value = "";
	}
}
/* ---------------------------------------------------------------------------
	日付のformat（yyyy/mm/dd）;
---------------------------------------------------------------------------- */
function generationFormat(val) {
	if (val != null && val != "") {
		let date = "";
		let year = val.getFullYear();
		let month = val.getMonth() + 1;
		let day = val.getDate();
		month = month.toString().padStart(2, "0");
		day = day.toString().padStart(2, "0");
		model.value = `${year}/${month}/${day}`; // yyyy/mm/dd形式に変換
		enteredOrNotCheck(model.value);
	} else {
		model.value = "";
	}
}
/* ---------------------------------------------------------------------------
	datepickerにフォーカスした時の処理
---------------------------------------------------------------------------- */
function focusActive() {
	titleActive.value = !titleActive.value;
}
/* ---------------------------------------------------------------------------
	mounted
---------------------------------------------------------------------------- */
onMounted(() => {
	// 入力項目の判定
	enteredOrNotCheck(model.value);
});
</script>
<style scoped lang="scss"></style>
